import { __spreadArrays } from "tslib";
import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import RoundCheckbox from '../../../RoundCheckbox';
import ToggleButton from '../../../ToggleButton';
import { ArrowDownThin } from '../../../Icons/ArrowDown';
import { IconSize } from '../../../Icons/IconWrap';
import { MobileContext } from '../../../Context';
import noop from '../../../utils/noop';
import s from './LiveSettingsDropdown.scss';
var NotificationType;
(function (NotificationType) {
    NotificationType["COMMENTS"] = "comments";
    NotificationType["REPLIES"] = "replies";
    NotificationType["MENTIONS"] = "mentions";
    NotificationType["ACTIVITY"] = "activity";
    NotificationType["CORRESPONDENCE"] = "correspondence";
})(NotificationType || (NotificationType = {}));
var notificationTypeOptions = [
    NotificationType.COMMENTS,
    NotificationType.REPLIES,
    NotificationType.MENTIONS,
    NotificationType.ACTIVITY,
    NotificationType.CORRESPONDENCE,
];
var LiveSettingsDropdown = function (_a) {
    var className = _a.className, enabled = _a.enabled, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.onOpen, onOpen = _c === void 0 ? noop : _c, _d = _a.onClose, onClose = _d === void 0 ? noop : _d;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _e = useState(Boolean(enabled)), status = _e[0], setStatus = _e[1];
    var _f = useState([]), notificationTypes = _f[0], setNotificationTypes = _f[1];
    var toggleNotificationType = function (type) { return function (checked) {
        if (checked) {
            setNotificationTypes(__spreadArrays(notificationTypes, [type]));
        }
        else {
            var updatedTypes = __spreadArrays(notificationTypes);
            updatedTypes.splice(notificationTypes.indexOf(type), 1);
            setNotificationTypes(updatedTypes);
        }
    }; };
    var makeToggleHandler = function (open) { return function () {
        var willOpen = typeof open !== 'undefined' ? open : !isOpen;
        willOpen ? onOpen() : onClose();
    }; };
    var onMouseEnter = isMobile ? undefined : makeToggleHandler(true);
    var onMouseLeave = isMobile ? undefined : makeToggleHandler(false);
    var onButtonClick = isMobile ? makeToggleHandler() : undefined;
    return (React.createElement("div", { className: classnames(s['root'], isOpen && s['open'], className), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        React.createElement("div", { className: s['dropdown-btn'], onClick: onButtonClick },
            React.createElement("span", { className: classnames(s['status-dot'], status && s['enabled']) }),
            t('siteHeader.notificationsMenu.live'),
            React.createElement(ArrowDownThin, { className: s['arrow-icon'], size: IconSize.SMALL })),
        React.createElement("div", { className: s['dropdown-menu'] },
            React.createElement("div", { className: s['live-description'] }, t('siteHeader.notificationsMenu.liveDescription')),
            React.createElement("label", { className: s['status-toggle'] },
                t('siteHeader.notificationsMenu.liveToggle'),
                React.createElement(ToggleButton, { value: status, onChange: function () { return setStatus(!status); } })),
            React.createElement("div", { className: classnames(s['notification-type'], status && s['active']) },
                React.createElement("div", { className: s['notification-type-title'] }, t('siteHeader.notificationsMenu.show')),
                React.createElement("ul", null, notificationTypeOptions.map(function (type) { return (React.createElement("li", { className: s['notification-type-filter'], key: "filter-" + type },
                    React.createElement(RoundCheckbox, { label: t("siteHeader.notificationsMenu.notificationType." + type), isChecked: notificationTypes.includes(type), onChange: toggleNotificationType(type), labelOnRight: true }))); }))))));
};
LiveSettingsDropdown.displayName = 'LiveSettingsDropdown';
export default LiveSettingsDropdown;
//# sourceMappingURL=LiveSettingsDropdown.js.map